import { render, staticRenderFns } from "./IdVerificationStatus.vue?vue&type=template&id=4af38677&scoped=true&"
import script from "./IdVerificationStatus.vue?vue&type=script&lang=js&"
export * from "./IdVerificationStatus.vue?vue&type=script&lang=js&"
import style0 from "./IdVerificationStatus.vue?vue&type=style&index=0&id=4af38677&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af38677",
  null
  
)

export default component.exports